// This file is auto-generated by @skynet/data-helpers/scripts/generate-rtk-exports.mjs
// Do not edit manually.

import { hookExports } from './dex-blockchains-api';

export const useListBlockchains: typeof hookExports.useListBlockchains =
  hookExports.useListBlockchains;
export const useLazyListBlockchains: typeof hookExports.useLazyListBlockchains =
  hookExports.useLazyListBlockchains;
export const useGetBlockchain: typeof hookExports.useGetBlockchain = hookExports.useGetBlockchain;
export const useLazyGetBlockchain: typeof hookExports.useLazyGetBlockchain =
  hookExports.useLazyGetBlockchain;
export const useCreateBlockchain: typeof hookExports.useCreateBlockchain =
  hookExports.useCreateBlockchain;
export const useUpdateBlockchain: typeof hookExports.useUpdateBlockchain =
  hookExports.useUpdateBlockchain;
export const useDeleteBlockchain: typeof hookExports.useDeleteBlockchain =
  hookExports.useDeleteBlockchain;
export const useChangeBlockchainNode: typeof hookExports.useChangeBlockchainNode =
  hookExports.useChangeBlockchainNode;
export const useSwitchBlockchainPrivateRPC: typeof hookExports.useSwitchBlockchainPrivateRPC =
  hookExports.useSwitchBlockchainPrivateRPC;
export const useReloadApp: typeof hookExports.useReloadApp = hookExports.useReloadApp;
